var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _path, _path2, _path3, _path4, _path5, _path6, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512.00038",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 169.9940010834,
    x2: 299.4934135904,
    y1: 71.98622701,
    y2: 349.0548448864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0077b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066b2"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0066b2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485e"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 364.2825237824,
    x2: -379.5864327114,
    xlinkHref: "#b",
    y1: 314.0868361356,
    y2: -84.9521808166
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 256.0003,
    x2: 256.0003,
    xlinkHref: "#b",
    y1: 415.8267010284,
    y2: 522.8344458318
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 271.3543834602,
    x2: 79.916898849,
    xlinkHref: "#b",
    y1: 273.7754525398,
    y2: 82.3380683208
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 383.7494748922,
    x2: -1.7565731078,
    xlinkHref: "#b",
    y1: 451.630876413,
    y2: 270.924916413
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 477.5305473456,
    x2: 208.9696664582,
    xlinkHref: "#b",
    y1: 491.2543726544,
    y2: 222.693491767
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m420.421875 503.234375c-109.503906 11.6875-219.339844 11.6875-328.84375 0-43.664063-4.660156-78.152344-39.148437-82.8125-82.816406-11.6875-109.503907-11.6875-219.335938 0-328.839844 4.660156-43.664063 39.148437-78.152344 82.8125-82.8125 109.503906-11.6875 219.335937-11.6875 328.839844 0 43.667969 4.660156 78.15625 39.148437 82.816406 82.8125 11.6875 109.503906 11.6875 219.335937 0 328.839844-4.660156 43.667969-39.144531 78.15625-82.8125 82.816406zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m475.386719 110.097656c-4.132813-38.746094-34.734375-69.351562-73.484375-73.488281-97.171875-10.367187-194.632813-10.367187-291.804688 0-38.746094 4.136719-69.351562 34.742187-73.488281 73.488281-10.367187 97.171875-10.367187 194.632813 0 291.800782 4.136719 38.75 34.742187 69.355468 73.488281 73.488281 97.171875 10.371093 194.632813 10.371093 291.800782 0 38.75-4.132813 69.355468-34.738281 73.488281-73.488281 10.371093-97.167969 10.371093-194.628907 0-291.800782zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.671875 409.804688c.351563 3.539062.714844 7.078124 1.09375 10.617187 4.660156 43.664063 39.148437 78.152344 82.816406 82.8125 109.503907 11.6875 219.335938 11.6875 328.839844 0 43.667969-4.660156 78.152344-39.148437 82.8125-82.8125.378906-3.539063.742187-7.078125 1.097656-10.617187zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m497.714844 443.570312-330.40625-330.410156c-7.378906-9.628906-18.988282-15.84375-32.054688-15.84375-22.289062 0-40.359375 18.066406-40.359375 40.355469 0 13.070313 6.21875 24.679687 15.847657 32.054687l329.257812 329.261719c26.613281-8.855469 47.824219-29.304687 57.714844-55.417969zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m169.152344 204.503906h-67.800782v210.179688l96.203126 96.203125c74.304687 2.8125 148.660156.269531 222.863281-7.652344 12.972656-1.382813 25.125-5.417969 35.9375-11.527344zm0 0",
    fill: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m399.410156 222.109375c-12.402344-13.597656-30.257812-22.128906-50.105468-22.128906-31.394532 0-51.65625 11.027343-63.714844 21.265625l-13.285156-16.742188h-62.472657v210.179688l96.492188 96.492187c38.054687-1.238281 76.09375-3.886719 114.097656-7.941406 43.667969-4.660156 78.152344-39.148437 82.8125-82.8125 3.117187-29.195313 5.394531-58.414063 6.847656-87.640625zm0 0",
    fill: "url(#g)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m101.355469 204.503906h67.796875v210.179688h-67.796875zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.304688 199.980469c-49.683594 0-71.507813 27.613281-77 36.019531v-31.496094h-62.472657v210.179688h67.800781v-105.574219c0-30.507813 14.042969-54.238281 40.679688-54.238281 26.632812 0 30.992188 29.539062 30.992188 65.863281v93.949219h67.800781v-146.902344c0-37.445312-30.355469-67.800781-67.800781-67.800781zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.609375 137.675781c0 22.289063-18.066406 40.355469-40.355469 40.355469-22.289062 0-40.359375-18.066406-40.359375-40.355469 0-22.289062 18.070313-40.359375 40.359375-40.359375 22.289063 0 40.355469 18.070313 40.355469 40.359375zm0 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.981931b1.svg";
export { ForwardRef as ReactComponent };